const Xarea = () => import('Views/x-area/index');
const XareaHome = () => import('Views/x-area/home');
const Country = () => import('Views/x-area/country-1-1');
const ResearchPersonnelRelations = () => import('Views/x-area/research-personnel-relations');
const TimeDistribution = () => import('Views/x-area/time-distribution');
const KeywordsTimeDistribution = () => import('Views/x-area/keywords-time-distribution');
const InternationalSituationAnalysis = () => import('Views/x-area/international-situation-analysis');
const InternationalCooperationDynamics = () => import('Views/x-area/international-cooperation-dynamics');
const DomesticSituationAnalysis = () => import('Views/x-area/domestic-situation-analysis');

export default[
  { path: '/x-area/:id',
    component: Xarea,
    children: [
      { path: '/x-area', component: XareaHome },
      { path: '/x-area/country', component: Country },
      { path: '/x-area/research-personnel-relations', component: ResearchPersonnelRelations },
      { path: '/x-area/time-distribution', component: TimeDistribution },
      { path: '/x-area/keywords-time-distribution', component: KeywordsTimeDistribution },
      { path: '/x-area/international-situation-analysis', component: InternationalSituationAnalysis },
      { path: '/x-area/international-cooperation-dynamics', component: InternationalCooperationDynamics },
      { path: '/x-area/domestic-situation-analysis', component: DomesticSituationAnalysis },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/x-area.js